export default __webpack_public_path__ + "static/media/7.1e916e4e.mp3";